import React from 'react';
import { Quote } from 'lucide-react';

const ClientTestimonial = ({ quote, name, title, company, variant = 'light' }) => {
  const isLight = variant === 'light';
  
  return (
    <div className={`rounded-xl p-6 lg:p-8 ${isLight ? 'bg-slate-50 border border-slate-100' : 'bg-white/5 border border-white/10'}`}>
      <div className="flex items-start gap-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${isLight ? 'bg-[#2693d0]/10' : 'bg-[#2693d0]/20'}`}>
          <Quote className="w-5 h-5 text-[#2693d0]" />
        </div>
        <div>
          <p className={`text-sm font-medium uppercase tracking-wide mb-3 ${isLight ? 'text-[#2693d0]' : 'text-[#2693d0]'}`}>
            Client Perspective
          </p>
          <blockquote className={`text-base lg:text-lg leading-relaxed mb-4 italic ${isLight ? 'text-slate-700' : 'text-slate-200'}`}>
            "{quote}"
          </blockquote>
          <div>
            <p className={`font-semibold ${isLight ? 'text-slate-800' : 'text-white'}`}>{name}</p>
            <p className={`text-sm ${isLight ? 'text-slate-500' : 'text-slate-400'}`}>
              {title}{company && `, ${company}`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientTestimonial;
